<ng-container *ngIf="state$ | async as state">
  <button class="heading" (click)="toggleGroup($event)">
    {{ facet.name }}
    <cx-icon class="collapse-icon" [type]="collapseIcon"></cx-icon>
    <cx-icon class="expand-icon" [type]="expandIcon"></cx-icon>
  </button>

  <a
    *ngFor="let value of facet.values | slice: 0 : state.topVisible"
    #facetValue
    routerLink="./"
    [queryParams]="getLinkParams(value)"
    class="value"
    [class.selected]="value.selected"
    [cxFocus]="$any(value.name)"
    (keydown.space)="openLink($any($event))"
    (click)="facetClick(value)"
    attr.aria-label="{{ 'productFacetNavigation.ariaLabelApplyFilter' | cxTranslate }}"
  >
    <span>
      <span class="label">{{ value.name }}</span>
      <span class="count">{{ value.count }}</span>
    </span>
  </a>

  <div class="more">
    <a
      *ngFor="let value of facet.values | slice: state.topVisible ?? 0 : state.maxVisible"
      #facetValue
      routerLink="./"
      [queryParams]="getLinkParams(value)"
      class="value"
      [class.selected]="value.selected"
      [cxFocus]="$any(value.name)"
      (keydown.space)="openLink($any($event))"
      (click)="facetClick(value)"
    >
      <span
        >{{ value.name }}<span class="count">{{ value.count }}</span></span
      >
    </a>
    <button
      *ngIf="(state.maxVisible ?? 0) > (state.topVisible ?? 0)"
      (click)="decreaseVisibleValues()"
      class="cx-action-link"
      [cxFocus]="$any('moreorless')"
    >
      {{ 'productList.showLess' | cxTranslate }}
    </button>

    <button
      *ngIf="(state.maxVisible ?? 0) > 0 && (state.maxVisible ?? 0) < (facet.values?.length ?? 0)"
      (click)="increaseVisibleValues()"
      class="cx-action-link"
      [cxFocus]="$any('moreorless')"
    >
      {{ 'productList.showMore' | cxTranslate }}
    </button>
  </div>
</ng-container>
